import { render } from "./ProfileAboutUs.vue?vue&type=template&id=5b20d037&scoped=true"
import script from "./ProfileAboutUs.vue?vue&type=script&lang=js"
export * from "./ProfileAboutUs.vue?vue&type=script&lang=js"

import "./ProfileAboutUs.vue?vue&type=style&index=0&id=5b20d037&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b20d037"]])

export default __exports__